import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2252b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between gap-2" }
const _hoisted_2 = { class: "p-input-icon-left float-right" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { MoneyUtils } from '@/utils/MoneyUtils';
import { DateUtils } from '@/utils/DateUtils';
import { DoctorPayoutInfo } from '@/interfaces/DoctorPayoutInfo';
import { ref, PropType, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useListFilters } from '@/stores/listFilters';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorPayoutList',
  props: {
  doctors: {
    type: Array as PropType<DoctorPayoutInfo[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const router = useRouter();
const listFilters = useListFilters();

const filteredDoctors = ref<DoctorPayoutInfo[]>([...props.doctors]);
const rowsPerPage = ref(listFilters.rows);

const onPage = (event: any) => {
  listFilters.setRows(event.rows);
};

const searchQuery = ref(listFilters.payoutFilter);

const safeDisplay = (value: string): string => value || '';

const clearFilter = () => {
  searchQuery.value = '';
  listFilters.clearPayoutFilter();
  filteredDoctors.value = [...props.doctors];
};

const removeDiacritics = (str: string) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const searchData = () => {
  const q = removeDiacritics(searchQuery.value?.toLowerCase().trim() || '');
  listFilters.setPayoutFilter(searchQuery.value ?? '');

  if (!q) {
    filteredDoctors.value = [...props.doctors];
    return;
  }

  filteredDoctors.value = props.doctors.filter((doctor) =>
    [doctor.title, doctor.firstName, doctor.lastName]
      .filter(Boolean)
      .map((field) => field!.trim())
      .some((field) =>
        removeDiacritics(field.toLowerCase()).includes(q)
      )
  );
};

const setDefaultProfileImage = (doctor: DoctorPayoutInfo) => {
  doctor.photoUrl =
    'https://img.freepik.com/free-vector/doctor-background-design_1270-62.jpg?w=2000';
};

const onSelectedRow = (event: any) => {
  if (event.data.status == 0) {
    console.log('Acest utilizator a fost sters');
  } else {
    const selectedDoctorId = event.data.id;
    router.push({ name: 'payout-details', params: { id: selectedDoctorId } });
  }
};

watch(
  () => props.doctors,
  (newValue) => {
    filteredDoctors.value = [...newValue];
    searchData();
  },
  { immediate: true }
);

const sortableDoctors = computed(() => {
  return filteredDoctors.value.map(d => ({
    ...d,
    sortName: `${d.title ?? ''} ${d.firstName ?? ''} ${d.lastName ?? ''}`.toLowerCase(),
    sortTotalAmount: d.totalAmount,
    sortDoctorAmount: d.doctorAmount,
    sortPlatformAmount: d.platformAmount,
    sortLatestPayout: d.latestPayoutTotalAmount ?? -999999999,
    sortLatestDate: d.latestPayoutDate ? new Date(d.latestPayoutDate).getTime() : 0
  }));
});


return (_ctx: any,_cache: any) => {
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: sortableDoctors.value,
      onRowSelect: onSelectedRow,
      onPage: onPage,
      selectionMode: "single",
      stripedRows: "",
      paginator: "",
      rows: rowsPerPage.value,
      rowsPerPageOptions: [5, 10, 20, 50]
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Button), {
            type: "button",
            class: "p-button-sm",
            icon: "pi pi-filter-slash",
            outlined: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter()))
          }),
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_IconField, null, {
              default: _withCtx(() => [
                _createVNode(_component_InputIcon, { class: "pi pi-search" }),
                _createVNode(_unref(InputText), {
                  class: "md:w-auto w-10rem",
                  onInput: searchData,
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                  placeholder: "Caută.."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), { header: "" }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Avatar, {
              image: data.photoUrl,
              icon: data.photoUrl ? undefined : 'pi pi-user',
              shape: "circle",
              size: "normal"
            }, null, 8, ["image", "icon"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Medic",
          field: "sortName",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", {
              innerHTML: 
              (data.status == 0
                ? '<i class=\'pi pi-times disabledrow\'></i> '
                : ' ') +
              safeDisplay(data.title) +
              ' ' +
              safeDisplay(data.firstName) +
              ' ' +
              safeDisplay(data.lastName)
            
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Total consultatii nedecontate",
          field: "sortTotalAmount",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.totalAmount, data.currency)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Beneficiu nedecontat",
          field: "sortDoctorAmount",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.doctorAmount, data.currency)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Comision nedecontat",
          field: "sortPlatformAmount",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(MoneyUtils).format(data.platformAmount, data.currency)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Ultima decontare",
          field: "sortLatestPayout",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            (data.latestPayoutTotalAmount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(MoneyUtils).format(data.latestPayoutTotalAmount, data.currency)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, " N/A "))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Data ultima decontare",
          field: "sortLatestDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            (data.latestPayoutDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(DateUtils).format(data.latestPayoutDate)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, " N/A "))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "rows"])
  ]))
}
}

})